import { ethers } from 'ethers'
import { useEffect, useState } from 'react'
import axios from 'axios'


import Web3Modal from 'web3modal'
import {
  nftaddress, nftmarketaddress
} from '../../polygan/config';




import NFT from '../../utils/polygon/NFT.json';
import Market from '../../utils/polygon/NFTMarket.json';












export default function PolyCreatorpage() {








  const [nfts, setNfts] = useState([])
  const [sold, setSold] = useState([])
  const [loadingState, setLoadingState] = useState('not-loaded')
  useEffect(() => {
    loadNFTs()
  }, [])
  async function loadNFTs() {
    const web3Modal = new Web3Modal({
      network: "mainnet",
      cacheProvider: true,
    })
    const connection = await web3Modal.connect()
    const provider = new ethers.providers.Web3Provider(connection)
    const signer = provider.getSigner()

    const marketContract = new ethers.Contract(nftmarketaddress, Market.abi, signer)
    const tokenContract = new ethers.Contract(nftaddress, NFT.abi, provider)
    const data = await marketContract.fetchItemsCreated()

    const items = await Promise.all(data.map(async i => {
      const tokenUri = await tokenContract.tokenURI(i.tokenId)
      const meta = await axios.get(tokenUri)
      let price = ethers.utils.formatUnits(i.price.toString(), 'ether')
 
  
      let item = {
        price,
        tokenId: i.tokenId.toNumber(),
        seller: i.seller,
        owner: i.owner,
        sold: i.sold,
        image: meta.data.image,
      
       
      }
      return item
    }))
    /* create a filtered array of items that have been sold */
    const soldItems = items.filter(i => i.sold)
    setSold(soldItems)
    setNfts(items)
    console.log("sold items")
    console.log(sold)
    setLoadingState('loaded')
  }
  if (loadingState === 'loaded' && !nfts.length) return (<h1 className="py-10 px-20 text-3xl">No assets created</h1>)
  return (
    <div>
      <div className="p-4">
        <h2 className="">Items Created</h2>

    


        <div className='p-4'>


          {
            nfts.map((nft, i) => (


              <div className=' col-lg-3 col-sm-1 col-md-6 d-inline-block p-3 ' >

                <div className=''>

                  <div className=' bg-dark  border border-muted rounded-9 '>


                    <div className='card    rounded-9 bggtimer '>
                      <div className='card   border border-muted rounded-9 bggtimer'>

                        <img src={nft.image} className='rounded-9 p-3  ch'></img>



                        <h5 className=' fw-bolder mx-3 text-light'>{nft.name}</h5>
                        <p className=' fw-bolder mx-3 text-light'>{nft.description}</p>



                        {/* if you want to show current owner show that */}


                        <p className=' fw-bolder mx-3 text-light'>owner: <span className='tx-sm'>{nft.owner}</span></p>
                        <p className=' fw-bolder mx-3 text-light'>seller: <span className='tx-sm'>{nft.seller}</span></p>

                      </div>
                      <span class="badge rounded-pill badge-notification bg-dark mt-3  p-3 align-self-end  hover-overlay border border-muted" > <i class="fas fa-heart"></i>  60 </span>

                    </div>
                    <div className='container'>
                      <div className='row mt-3 fw-bold text-light'>
                        <div className='col-6'>
                          <h6>RESERVE PRICE</h6>
                          <h5>{nft.price}</h5>

                        </div>
                        <div className='col-6'>
                          <h6>SHARE</h6>
                          <h6><i class="fab fa-facebook-square "><i class="fab fa-twitter mx-3"></i></i><i class="fab fa-instagram"></i></h6>

                        </div>

                      </div>



                    </div>










                  </div>

                </div>
              </div>))
          }
        </div>
      </div>
      <div className="px-4">
        {
          Boolean(sold.length) && (
            <div>
              <h2 className="text-2xl py-2">Items sold</h2>
              <div className="">
                {/* {
                  sold.map((nft, i) => (
                    <div key={i} className="border shadow rounded-xl overflow-hidden">
                      <img src={nft.image} className="rounded" />
                      <div className="p-4 bg-black">
                        <p className=" font-bold text-white">Price - {nft.price} Eth</p>
                      </div>
                    </div>
                  ))
                } */}



                <div className='p-4'>


                  {
                    sold.map((nft, i) => (


                      <div className=' col-lg-3 col-sm-1 col-md-6 d-inline-block p-3 ' >

                        <div className=''>

                          <div className=' bg-dark  border border-muted rounded-9 '>


                            <div className='card    rounded-9 bggtimer '>
                              <div className='card   border border-muted rounded-9 bggtimer'>

                                <img src={nft.image} className='rounded-9 p-3  ch'></img>




                                <h5 className=' fw-bolder mx-3 text-light'>{nft.name}</h5>
                                <p className=' fw-bolder mx-3 text-light'>{nft.description}</p>



                                {/* if you want to show current owner show that */}


                                <p className=' fw-bolder mx-3 text-light'>owner: <span className='tx-sm'>{nft.owner}</span></p>
                                <p className=' fw-bolder mx-3 text-light'>seller: <span className='tx-sm'>{nft.seller}</span></p>

                              </div>
                              <span class="badge rounded-pill badge-notification bg-dark mt-3  p-3 align-self-end  hover-overlay border border-muted" > <i class="fas fa-heart"></i>  60 </span>

                            </div>
                            <div className='container'>
                              <div className='row mt-3 fw-bold text-light'>
                                <div className='col-6'>
                                  <h6>RESERVE PRICE</h6>
                                  <h5>{nft.price}</h5>

                                </div>
                                <div className='col-6'>
                                  <h6>SHARE</h6>
                                  <h6><i class="fab fa-facebook-square "><i class="fab fa-twitter mx-3"></i></i><i class="fab fa-instagram"></i></h6>

                                </div>

                              </div>



                            </div>










                          </div>

                        </div>
                      </div>))
                  }
                </div>
              </div>
            </div>
          )
        }
      </div>
    </div>
  )
}